/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import Divider from "@mui/material/Divider";

import RailIconFO from "../../icons/RailIconFO"; // HERE
import TruckIconFO from "../../icons/TruckIconFO"; // HERE

import { BargeIcon, PipelineIcon, VesselIcon } from "../../icons";
import { IMode } from "../../types/IModes";
import ILocation from "../../types/ILocation";

import LogisticsRow from "./components/LogistcsRow";
import RailSettings from "./components/RailSettings";
import { toModes } from "../../utils/utils";
import { IStationRow } from "../../types/IRailFreightDetails";

const Logistics = ({
  originalLocation,
  location,
  setLocation,
  disabled,
  onAdditionalRowsDirtyChange,
  onRailStationsChange,
}: {
  originalLocation?: ILocation;
  location: ILocation;
  setLocation: (location: ILocation) => void;
  disabled?: boolean;
  onAdditionalRowsDirtyChange?: (hasDirtyAdditionalRow: boolean) => void;
  onRailStationsChange?: (railStations: IStationRow[]) => void;
}) => {
  const modes = toModes(location.inboundModes, location.outboundModes);

  const updateMode = (mode: IMode) => {
    const updatedModes = { ...modes };
    updatedModes[mode.name.toUpperCase() as keyof typeof updatedModes] = mode;

    setLocation({
      ...location,
      inboundModes: Object.values(updatedModes)
        .filter((m) => m.inbound)
        .map((m) => m.name.toUpperCase()),
      outboundModes: Object.values(updatedModes)
        .filter((m) => m.outbound)
        .map((m) => m.name.toUpperCase()),
    });
  };

  const [zipCode, setZipCode] = useState(originalLocation?.zipCode || "");
  useEffect(() => {
    if (originalLocation?.zipCode && originalLocation?.zipCode !== zipCode) {
      setZipCode(originalLocation?.zipCode);
    } else if (location.zipCode && location.zipCode !== zipCode) {
      setZipCode(location.zipCode);
    }
  }, [originalLocation, location]);

  return (
    <div
      style={{
        flexGrow: 1,
        paddingTop: 0,
        display: "flex",
        flexDirection: "column",
        gap: 8,
        color: "#4B4B4B",
        fontSize: 14,
        fontWeight: 400,
      }}
    >
      {/* Truck */}
      <LogisticsRow
        label="Truck"
        icon={<TruckIconFO color="#09B0F2" size="20" />}
        mode={modes.TRUCK}
        updateMode={updateMode}
        disabled={disabled}
      />

      <Divider />
      {/* Rail */}
      <LogisticsRow
        label="Rail"
        icon={<RailIconFO color="#09B0F2" size="20" />}
        mode={modes.RAIL}
        updateMode={(mode: IMode) => {
          if (!mode.inbound && !mode.outbound) {
            setLocation({
              ...location,
              stationState: "",
              equipmentTypes: [],
              carriers: [],
              railStations: [],
            });
          }

          updateMode(mode);
        }}
        disabled={disabled}
      >
        <div>
          {(location.inboundModes.includes("RAIL") ||
            location.outboundModes.includes("RAIL")) && (
            <div style={{ paddingLeft: 40 }}>
              <RailSettings
                originalLocation={originalLocation}
                location={location}
                setLocation={setLocation}
                zipCode={zipCode}
                disabled={disabled}
                onAdditionalRowsDirtyChange={onAdditionalRowsDirtyChange}
                onRailStationsChange={onRailStationsChange}
              />
            </div>
          )}
        </div>
      </LogisticsRow>

      <Divider />

      {/* Vessel */}
      <LogisticsRow
        label="Vessel"
        icon={<VesselIcon color="#09B0F2" />}
        mode={modes.VESSEL}
        updateMode={updateMode}
        disabled={disabled}
      />
      <Divider />

      {/* Barge  */}
      <LogisticsRow
        label="Barge"
        icon={<BargeIcon color="#09B0F2" />}
        mode={modes.BARGE}
        updateMode={updateMode}
        disabled={disabled}
      />
      <Divider />

      {/* Pipeline */}
      <LogisticsRow
        label="Pipeline"
        icon={<PipelineIcon color="#09B0F2" />}
        mode={modes.PIPELINE}
        updateMode={updateMode}
        disabled={disabled}
      />
    </div>
  );
};

export default Logistics;
